const listItems = document.querySelectorAll(
    '.MegaNav__item > .MegaNav__itemLink[aria-haspopup="true"]',
);
const goBackBtns = document.querySelectorAll('.menu-nav-go-back-button');
const menuContainer = document.querySelector('.MegaNav');
const mobileSearchButton = document.querySelector('[data-mobile-menu-search]');
const mobileCartButton = document.querySelector('[data-mobile-menu-cart]');

const query = window.matchMedia('(max-width: 1023px)');
const OPEN_MENU_SELECTOR = '.MegaNav__subMenu.open';
const OPEN_MOBILE_PANEL_SELECTOR = '.MegaNav__subMenu.open';
const OPEN_ITEM_CLASS = 'MegaNav__item--open';
const DRAG_START_THRESHOLD = 6;
const CLICK_BLOCK_DURATION = 400;

const getDirectSubMenu = (parent) =>
    Array.from(parent.children).find((child) => child.tagName === 'UL');

const getClosestOpenMenu = (trigger) => trigger.closest(OPEN_MOBILE_PANEL_SELECTOR);

const setItemExpanded = (item, isExpanded) => {
    const trigger = item?.querySelector(':scope > .MegaNav__itemLink[aria-expanded]');
    trigger?.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
};

const closeOpenMenus = (exceptMenu = null) => {
    document.querySelectorAll(OPEN_MENU_SELECTOR).forEach((menu) => {
        if (menu !== exceptMenu) {
            menu.classList.remove('open');
            setItemExpanded(menu.parentElement, false);
        }
    });

    document.querySelectorAll(`.${OPEN_ITEM_CLASS}`).forEach((item) => {
        if (!exceptMenu || !item.contains(exceptMenu)) {
            item.classList.remove(OPEN_ITEM_CLASS);
            setItemExpanded(item, false);
        }
    });
};

const handleSubMenu = (ev) => {
    const clickedLink = ev.currentTarget;
    const parent = clickedLink.closest('li');
    const nestedMenu = parent ? getDirectSubMenu(parent) : null;

    if (!nestedMenu) {
        return;
    }

    ev.preventDefault();

    if (query.matches) {
        nestedMenu.classList.add('open');
        setItemExpanded(parent, true);
        return;
    }

    if (!clickedLink.classList.contains('MegaNav__itemLink')) {
        return;
    }

    const shouldOpen = !nestedMenu.classList.contains('open');

    closeOpenMenus(nestedMenu);
    nestedMenu.classList.toggle('open', shouldOpen);
    parent.classList.toggle(OPEN_ITEM_CLASS, shouldOpen);
    setItemExpanded(parent, shouldOpen);
};

goBackBtns.forEach((btn) => {
    btn.addEventListener('click', (ev) => {
        ev.preventDefault();

        const openMenu = getClosestOpenMenu(btn);
        openMenu?.classList.remove('open');
        setItemExpanded(openMenu?.parentElement, false);
    });
});

listItems?.forEach((listItem) => listItem.addEventListener('click', handleSubMenu));

const activateHeaderAction = (selector) => {
    closeOpenMenus();
    document.getElementById('closeMenuButton')?.click();

    window.requestAnimationFrame(() => {
        document.querySelector(selector)?.click();
    });
};

mobileSearchButton?.addEventListener('click', () => activateHeaderAction('#open-search-button'));
mobileCartButton?.addEventListener('click', () => activateHeaderAction('#open-cart-btn'));

document.addEventListener('click', (ev) => {
    if (query.matches || !menuContainer || menuContainer.contains(ev.target)) {
        return;
    }

    closeOpenMenus();
});

document.querySelectorAll('.MegaNav__desktopTileShell').forEach((shell) => {
    const rail = shell?.querySelector('[data-mega-rail]');
    const prevButton = shell?.querySelector('[data-mega-rail-prev]');
    const nextButton = shell?.querySelector('[data-mega-rail-next]');

    if (!rail) {
        return;
    }

    const syncArrowVisibility = () => {
        const maxScrollLeft = rail.scrollWidth - rail.clientWidth;
        const canScroll = maxScrollLeft > 2;
        const isAtStart = rail.scrollLeft <= 2;
        const isAtEnd = rail.scrollLeft >= maxScrollLeft - 2;

        if (prevButton) {
            prevButton.hidden = !canScroll || isAtStart;
        }

        if (nextButton) {
            nextButton.hidden = !canScroll || isAtEnd;
        }
    };

    const scrollRail = (direction) => {
        const distance = Math.max(rail.clientWidth * 0.72, 280) * direction;

        rail.scrollBy({
            left: distance,
            behavior: 'smooth',
        });

        window.setTimeout(syncArrowVisibility, 360);
    };

    let activePointerId = null;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let isDragging = false;
    let blockClicksUntil = 0;

    const finishDrag = (ev) => {
        if (activePointerId !== ev.pointerId) {
            return;
        }

        const pointerId = activePointerId;
        const wasDragging = isDragging;

        activePointerId = null;
        isDragging = false;
        rail.classList.remove('is-dragging');

        if (
            typeof rail.hasPointerCapture === 'function' &&
            rail.hasPointerCapture(pointerId)
        ) {
            rail.releasePointerCapture(pointerId);
        }

        if (wasDragging) {
            blockClicksUntil = Date.now() + CLICK_BLOCK_DURATION;
        }

        window.requestAnimationFrame(syncArrowVisibility);
    };

    rail.addEventListener('pointerdown', (ev) => {
        const isUnsupportedMouseButton = ev.pointerType === 'mouse' && ev.button !== 0;

        if (!ev.isPrimary || activePointerId !== null || isUnsupportedMouseButton) {
            return;
        }

        activePointerId = ev.pointerId;
        startX = ev.clientX;
        startY = ev.clientY;
        startScrollLeft = rail.scrollLeft;
        isDragging = false;
    });

    rail.addEventListener('pointermove', (ev) => {
        if (activePointerId !== ev.pointerId) {
            return;
        }

        const deltaX = ev.clientX - startX;
        const deltaY = ev.clientY - startY;

        if (!isDragging) {
            const hasPassedThreshold =
                Math.max(Math.abs(deltaX), Math.abs(deltaY)) >= DRAG_START_THRESHOLD;

            if (!hasPassedThreshold) {
                return;
            }

            if (Math.abs(deltaY) >= Math.abs(deltaX)) {
                activePointerId = null;
                return;
            }

            isDragging = true;
            rail.classList.add('is-dragging');

            if (typeof rail.setPointerCapture === 'function') {
                rail.setPointerCapture(ev.pointerId);
            }
        }

        ev.preventDefault();
        rail.scrollLeft = startScrollLeft - deltaX;
        syncArrowVisibility();
    });

    window.addEventListener('pointerup', finishDrag);
    window.addEventListener('pointercancel', finishDrag);
    rail.addEventListener('lostpointercapture', finishDrag);
    rail.addEventListener('dragstart', (ev) => ev.preventDefault());
    rail.addEventListener(
        'click',
        (ev) => {
            if (Date.now() > blockClicksUntil) {
                return;
            }

            ev.preventDefault();
            ev.stopPropagation();
            blockClicksUntil = 0;
        },
        true,
    );

    prevButton?.addEventListener('click', (ev) => {
        ev.preventDefault();
        scrollRail(-1);
    });

    nextButton?.addEventListener('click', (ev) => {
        ev.preventDefault();
        scrollRail(1);
    });

    rail.addEventListener('scroll', () => window.requestAnimationFrame(syncArrowVisibility));
    window.requestAnimationFrame(syncArrowVisibility);
    window.addEventListener('resize', syncArrowVisibility);
});

query.addEventListener('change', () => {
    closeOpenMenus();
});
